import { render, staticRenderFns } from "./BeeLivePreview.vue?vue&type=template&id=27ca86dc"
import script from "./BeeLivePreview.vue?vue&type=script&lang=js"
export * from "./BeeLivePreview.vue?vue&type=script&lang=js"
import style0 from "./BeeLivePreview.vue?vue&type=style&index=0&id=27ca86dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports